import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/axiosInstance';

export default function LogsPreview() {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);;
    const navigate = useNavigate();

    useEffect(() => {
        const fetchLogs = async () => {
            try {
                const response = await api.get('/invoco/logs', { params: {limit: 10}});
                setLogs(response.data);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };
        fetchLogs();
    }, [])

    if (loading) return <p className='text-gray-500'>Loading logs...</p>

    return (
        <div className='p-4 mb-6'>
            <div className='flex justify-between mx-3 my-2 items-center '>
                <h3 className='text-lg font-bold text-gray-700'>Recent Logs</h3>
                <button className='text-docpgrPurple border py-1 px-3 rounded-lg hover:text-white hover:bg-docpgrPurple90 font-semibold bg-docpgrPurple10' onClick={() => navigate('/logs')}>
                        View All
                </button>
            </div>

            {/* Desktop table  */}
            <div className="hidden md:block overflow-x-auto">
                <table className='min-w-full table-auto border-collapse text-sm rounded-2xl'>
                    <thead>
                        <tr className='bg-docpgrPurple10'>
                            <th className="border px-2 py-1">
                                Timestamp
                            </th>
                            <th className="border px-2 py-1">
                                Room
                            </th>
                            <th className="border px-2 py-1">
                                Doctor
                            </th>
                            <th className="border px-2 py-1">
                                Status
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {logs.map(log => (
                            <tr key={log.log_id} className="hover:bg-gray-50">
                                <td className="border px-2 py-1">
                                    {new Date(log.timestamp).toLocaleString()}
                                </td>
                                <td className="border px-2 py-1">
                                    {log.room_name}
                                </td>
                                <td className="border px-2 py-1">
                                    {log.doctor_name || '-'}
                                </td>
                                <td className="border px-2 py-1">
                                    {log.status}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Mobile  */}
            <div className='block md:hidden space-y-3'>
                {logs.map((log) => (
                    <div key={log.log_id} className='border rounded-lg p-3 bg-white shadow-sm'>
                        <p className='text-sm text-gray-600'>
                            <span className="font-semibold text-gray-700">Timestamp:</span>{' '}
                            {new Date(log.timestamp).toLocaleString()}
                        </p>
                        <p className='text-sm text-gray-600'>
                            <span className='font-semibold text-gray-700'>Room:</span> {log.room_name || '-'}
                        </p>
                        <p className="text-sm text-gray-600">
                            <span className='font-semibold text-gray-700'>Doctor:</span>{' '}
                            {log.doctor_name || '-'}
                        </p>
                        <p className='text-sm text-gray-600'>
                            <span className='font-semibold text-gray-700'>Status:</span> {log.status}
                        </p>
                    </div>
                ))}
            </div>

            <div className='flex justify-end mx-3 my-2'>
                <button className='text-docpgrPurple border py-1 px-3 rounded-lg hover:text-white hover:bg-docpgrPurple90 font-semibold bg-docpgrPurple10' onClick={() => navigate('/logs')}>
                        View All
                </button>
            </div>
        </div>
    )

}
